import './FolderItemForm.css';

import React, { useState } from 'react';
import B2BFormContainer from '../../../b2b-common/B2BFormContainer';
import EditText from '../../../b2b-common/EditText';
import { createFolder, updateFolder } from '../../../../services/b2b-logbook-apiServices';
import { showNotification } from '../../../b2b-common/Notification';
import { useLoginContext } from '../../../../App';
import { useContentContext } from '../../../layout/Layout';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const FolderItemForm = ({ logbook, folder, onClose, onSaved }) => {

    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();
    const { t } = useB2BTranslation('b2b-logbook');

    const blankFolder = {
        logBookId: logbook.logBookId,
        logBookFolderId: 0,
        logBookFolderTime: new Date(),
        logBookFolderName: `${t('New Folder')}`,
        logBookFolderDescription: '',
    }
    const [currentFolder, setCurrentFolder] = useState(folder || blankFolder);

    const handleSave = async () => {
        if (folder !== null) { // Update
            try {
                const logbookUpdated = await updateFolder(loginData.accessToken, logbook.logBookId, currentFolder.logBookFolderId, currentFolder);
                showNotification(setNotification, t('Folder updated successfully.'), 'success', 3000);
                onSaved && onSaved(logbookUpdated);
            } catch (error) {
                console.error('Error updating folder:', error);
                showNotification(setNotification, t('Error updating folder: ') + error.response.statusText, 'error', 5000);
            }
        } else { // Create
            try {
                const logbookUpdated = await createFolder(loginData.accessToken, logbook.logBookId, currentFolder);
                showNotification(setNotification, t('Folder created successfully.'), 'success', 3000);
                onSaved && onSaved(logbookUpdated);
            } catch (error) {
                console.error('Error creating folder:', error);
                showNotification(setNotification, t('Error creating folder: ') + error.response.statusText, 'error', 5000);
            }
        }
    }

    return (
        <B2BFormContainer title={folder ? t('Folder Details') : t('New Folder')} onClose={onClose}
            showDivider={false}
            buttonsConfig={[
                { label: 'Save', onClick: handleSave },
            ]}
            className='folder-item-form'
        >
            <EditText object={currentFolder} objectField='logBookFolderName' setObjectField={setCurrentFolder} label={t('Folder Name')} />
            <EditText object={currentFolder} objectField='logBookFolderDescription' setObjectField={setCurrentFolder} label={t('Description')} multiline={true} rows={3} />
        </B2BFormContainer>
    )
}

export default FolderItemForm;